import { render, staticRenderFns } from "./SfHeading.vue?vue&type=template&id=2451306e&functional=true"
import script from "./SfHeading.vue?vue&type=script&lang=js"
export * from "./SfHeading.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfHeading.vue?vue&type=style&index=0&id=2451306e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "25ec1eb2"
  
)

export default component.exports